export default __webpack_public_path__ + "static/media/25.fa26810c.jpeg";